import type { CourseRun } from "@/common/courseRun/types";
import { isDateInPast, isValidDate } from "@/lib/date";
import type { Enrollment } from "@/lib/partner-api/getEnrollments";

export default function canCourseBePurchased(
  courseRun: Partial<CourseRun>,
  userEnrollments: Partial<Enrollment>[] | null,
) {
  const existingEnrollment = userEnrollments?.find(
    (enrollment) =>
      enrollment?.courseDetails?.courseId &&
      enrollment.courseDetails.courseId === courseRun?.key,
  );

  const enrollmentEnd = courseRun.enrollmentEnd
    ? new Date(courseRun.enrollmentEnd)
    : null;
  const courseRunEnd = courseRun.end ? new Date(courseRun.end) : null;
  const enrollmentStart = courseRun.enrollmentStart
    ? new Date(courseRun.enrollmentStart)
    : null;

  if (
    // user is enrolled in non-audit mode
    (existingEnrollment && existingEnrollment.mode !== "audit") ||
    // enrollment ended
    (enrollmentEnd && isValidDate(enrollmentEnd)
      ? isDateInPast(enrollmentEnd)
      : false) ||
    // course run ended
    (courseRunEnd && isValidDate(courseRunEnd)
      ? isDateInPast(courseRunEnd)
      : false) ||
    // enrollment hasn't started
    (enrollmentStart &&
      isValidDate(enrollmentStart) &&
      !isDateInPast(enrollmentStart))
  ) {
    return false;
  }
  return true;
}
